import React, { useState, useEffect } from 'react';
import { format, startOfWeek, endOfWeek, eachDayOfInterval, addWeeks, subWeeks } from 'date-fns';
import CardDia from './../CardDia/cardDia.jsx';
import es from 'date-fns/locale/es';
import './CardSemana.css';
import { useSelector } from 'react-redux';
import { logger } from '../../utils/logger.js';
import Modal from 'react-modal';
import FormularioCargaHora from '../cardCargaDehora/FormularioCargaHora.jsx';
import './../Modal/Modal.css';


function Semana() {
  // Controla el modal de "Carga semanal" (cargar lo mismo en varios días a la vez)
  const [mostrarCargaSemanal, setMostrarCargaSemanal] = useState(false);
  /// Define el estado local semanaActual y su función de actualización setSemanaActual, inicializado con la fecha actual
  const [semanaActual, setSemanaActual] = useState(new Date());
  // Define un array con los nombres de los días de la semana
  const dias = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];
  // Calcula el inicio y el fin de la semana actual
  const inicioSemana = startOfWeek(semanaActual, { weekStartsOn: 1 });
  const finSemana = endOfWeek(semanaActual, { weekStartsOn: 1 });
  // Crea un array con las fechas de cada día de la semana actual
  const fechas = eachDayOfInterval({ start: inicioSemana, end: finSemana }).map(dia => format(dia, 'dd/MM/yyyy', { locale: es }));
  // Rango de la semana para mostrar en el encabezado (ej: "8 – 14 jun 2026")
  const rangoSemana = `${format(inicioSemana, 'd', { locale: es })} – ${format(finSemana, "d 'de' MMMM yyyy", { locale: es })}`;
  // Obtiene el ID del usuario actual del estado de Redux
  const usuarioId = useSelector(state => state.session && state.session.id ? state.session.id : null);
  //const [loading, setLoading] = useState(true); 
  
  
  // Todas las horas del usuario (state.horas es un array). Se usa para el total semanal.
  const horasGlobal = useSelector(state => Array.isArray(state.horas) ? state.horas : []);

  // Obtiene las horas cargadas de la semana actual del estado de Redux
  const horasCargadas = useSelector(state => {
    const horasSemanaActual = {};
    fechas.forEach(fecha => {
      if (state.horas && state.horas[fecha]) {
        horasSemanaActual[fecha] = state.horas[fecha].filter(hora => hora.usuarioId === usuarioId);
      }
    });
    return horasSemanaActual;
  });

  // Total de horas cargadas en toda la semana visible.
  // state.horas es un array de todas las horas del usuario; filtramos por la semana visible.
  const totalSemana = Math.round(
    horasGlobal
      .filter(hora => hora.usuarioId === usuarioId && fechas.includes(hora.fechaCarga))
      .reduce((total, hora) => total + Number(hora.horas || 0), 0) * 100
  ) / 100;

  // Define la función para ir a la semana anterior
  const irASemanaAnterior = () => {
    const nuevaSemana = subWeeks(semanaActual, 1);
    setSemanaActual(nuevaSemana);
    localStorage.setItem('semanaActual', nuevaSemana.toISOString());
  };

  // Define la función para ir a la semana siguiente
  const irASemanaSiguiente = () => {
    const nuevaSemana = addWeeks(semanaActual, 1);
    setSemanaActual(nuevaSemana);
    localStorage.setItem('semanaActual', nuevaSemana.toISOString());
  };
  
// Define un efecto para cargar la semana actual guardada en localStorage cuando el componente se monta
  useEffect(() => {
    const semanaGuardada = localStorage.getItem('semanaActual');
    if (semanaGuardada) {
      setSemanaActual(new Date(semanaGuardada));
    }
  }, []);

/* useEffect(() => {
    dispatch(obtenerHoras())
      .then(() => setLoading(false))
      .catch(error => {
        logger.error('Error al obtener las horas:', error);
        setLoading(false);
      });
    }, [dispatch]);*/

    // Retorna el JSX para renderizar el componente

  return (
    <div>

      <div className='btnSemana'>
        <button className='btnSemanaIzq' onClick={irASemanaAnterior} aria-label="Semana anterior">
          <span className='flechaSemana'>&#8249;</span>
        </button>
        <h2 className='textSemana'>{rangoSemana}</h2>
        <button className='btnSemanaDer' onClick={irASemanaSiguiente} aria-label="Semana siguiente">
          <span className='flechaSemana'>&#8250;</span>
        </button>
      </div>
      <div className='totalSemana'>
        <span>Total de la semana: <span className='totalSemana__valor'>{totalSemana} h</span></span>
        <button className='btnCargaSemanal' onClick={() => setMostrarCargaSemanal(true)}>
          + Carga semanal
        </button>
      </div>
      <div className='cardsemana'>
        {dias.map((dia, index) => (
          <CardDia key={index} dia={dia} fecha={fechas[index]} horasCargadas={horasCargadas[fechas[index]] || []}/>
        ))}
      </div>

      <Modal
        isOpen={mostrarCargaSemanal}
        onRequestClose={() => setMostrarCargaSemanal(false)}
        className="FormModal__content"
        overlayClassName="FormModal__overlay"
      >
        <FormularioCargaHora
          modoSemanal={true}
          fecha={fechas[0]}
          onSubmit={() => {}}
          onClose={() => setMostrarCargaSemanal(false)}
        />
      </Modal>
    </div>
  );
}


export default React.memo(Semana);
